// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container___nM20","title":"Terms_title__f2bmc","heading":"Terms_heading__CNaFF","list":"Terms_list__ZEUQ8","paragraph":"Terms_paragraph__ckxvh"};